"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HsvInfo = exports.RtfColorIndexCollection = void 0;
var color_model_info_cache_1 = require("../../../core/model/caches/hashed-caches/color-model-info-cache");
var RtfColorIndexCollection = (function () {
    function RtfColorIndexCollection() {
        this.collection = [];
    }
    RtfColorIndexCollection.prototype.getRtfColorIndexById = function (id) {
        if (id < 0 || id >= this.collection.length)
            return color_model_info_cache_1.ColorModelInfoCache.defaultItem;
        return this.collection[id];
    };
    return RtfColorIndexCollection;
}());
exports.RtfColorIndexCollection = RtfColorIndexCollection;
var HsvInfo = (function () {
    function HsvInfo() {
    }
    return HsvInfo;
}());
exports.HsvInfo = HsvInfo;
